/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/hypergate': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.383 12-12S22.617 4 16 4zm1.05 1.553c4.953.492 8.905 4.444 9.397 9.398l-.996.098c-.444-4.48-4.02-8.056-8.501-8.5l.1-.996zm-2.1 0l.1.996c-4.481.444-8.057 4.02-8.501 8.5l-.996-.098c.492-4.954 4.444-8.906 9.397-9.398zm0 20.894c-4.953-.492-8.905-4.444-9.397-9.398l.996-.098c.444 4.48 4.02 8.056 8.501 8.5l-.1.996zM8 16c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8zm9.05 10.447l-.1-.996c4.481-.444 8.057-4.02 8.501-8.5l.996.098c-.492 4.954-4.444 8.906-9.397 9.398zM4 3h1v3H4z"/><path pid="1" d="M3 4h3v1H3zM4 26h1v3H4z"/><path pid="2" d="M3 27h3v1H3zM27 26h1v3h-1z"/><path pid="3" d="M26 27h3v1h-3zM27 3h1v3h-1z"/><path pid="4" d="M26 4h3v1h-3z"/>'
  }
})
